<script lang="ts">
  import Translate from "./locale.svelte";

  export let label: string = "";
  export let color: string = "var(--color-status-red)";
  export let subtitle: string = null;
</script>

<div class="Alert" role="alert" style="--status-color: {color};">
  <span class="Title">
    <Translate {label} />
  </span>

  {#if subtitle}
    <span class="Subtitle">
      {subtitle}
    </span>
  {/if}
</div>

<style>
  .Alert {
    border-left: 4px solid var(--status-color);
    border-radius: 2px;
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.08),
      0 1px 4px rgba(0, 0, 0, 0.2);
    color: var(--color-status-red);
    margin: var(--outer-padding);
    padding: 10px calc(var(--outer-padding) - 4px);
  }

  .Title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
  }

  .Subtitle {
    display: block;
    font-size: 90%;
    color: black;
    margin-top: 2px;
  }
</style>
